var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.DataMngrExtDataRequestAdv = new Class({
    Extends: OCS.Viewer.Classes.DataMngrDataRequest,
    class_name: "DataMngrExtDataRequestAdv",
    options: {
        date_request: false,
        data_category_keys: {'variables': "JSON"},
        metadata: {
            req_cat_type: 'DataMngrAdvDataRequest'
        }
    },

    is_data_valid: function (data) {
        var metadata = data.get_info();
        var dataset = data.get_dataset();
        if (data && dataset === this.options.metadata.dataset) {
            if (this.options.metadata.url !== undefined && this.options.metadata.url !== null && this.options.metadata.url !== "") {
                if (this.options.metadata.url === metadata.url) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        }
        return false;

    },
    is_valid: function () {
        var ops = this.get_metadata();
        if (ops.dataset && (ops.variables.length || this.has_url()) && this.failure_count < this.options.max_failure_attempts) {
            return true;
        } else {
            return false;
        }
    },
});
